import { render } from "./CardTemplate.vue?vue&type=template&id=4f09b4f4&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=4f09b4f4&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f09b4f4"]])

export default __exports__